const routes = []

// 개발 모드일 때만 playground 라우트 추가함
if (process.env.NODE_ENV === 'development') {
  const playgroundRoutes = [
    {
      path: '/playground',
      name: 'playground',
      components: {
        playground: () => import('@/components/Icons/IconGallery.vue'),
      },
      children: [
        {
          path: 'icon-gallery',
          name: 'IconGallery',
          components: {
            IconGallery: () => import('@/components/Icons/IconGallery.vue'),
          },
        },
      ],
    },
  ]
  routes.push(...playgroundRoutes)
}

export default routes
